import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledTextField = styled.div`
    margin: 10px 0 0 0;
    line-height: 1.5;
    font-size: 16px;
`;

const TextField = (props) => {
    return (
        <StyledTextField>
            { props.children }
        </StyledTextField>
    );
};

TextField.propTypes = {
    children: PropTypes.node.isRequired,
};

export default TextField;



// WEBPACK FOOTER //
// ./src/components/ui/general/TextField.js